import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6a9a9ffe")

_pushScopeId("data-v-6a9a9ffe")
const _hoisted_1 = { class: "fridgecoolingassistsettings-page" }
const _hoisted_2 = { class: "fridgecoolingassistsettings-page-select" }
const _hoisted_3 = { class: "fridgecoolingassistsettings-page-content" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_FridgeDetailsSelectDateBar = _resolveComponent("FridgeDetailsSelectDateBar")
  const _component_FridgeDetailsCoolingAssistSettingsItem = _resolveComponent("FridgeDetailsCoolingAssistSettingsItem")
  const _component_HorizontalPaging = _resolveComponent("HorizontalPaging")
  const _component_FridgeDetailsConfirmCoolingAssistSettingDialog = _resolveComponent("FridgeDetailsConfirmCoolingAssistSettingDialog")
  const _component_CommonDesignDialog = _resolveComponent("CommonDesignDialog")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_FridgeDetailsSelectDateBar, {
        key: _ctx.selectPageIndex,
        dateList: _ctx.functionList,
        type: _ctx.displayType,
        selectIndex: _ctx.selectPageIndex,
        isDisableButtonHidden: _ctx.isDisableButtonHidden,
        onOnSelect: _ctx.changePageIndex
      }, null, 8, ["dateList", "type", "selectIndex", "isDisableButtonHidden", "onOnSelect"])
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_HorizontalPaging, {
        class: "fridgecoolingassistsettings-page-content-content",
        currentPageIndex: _ctx.selectPageIndex,
        initialPageIndex: _ctx.initialPageIndex,
        onOnSelect: _ctx.selectPage
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
            return (_openBlock(), _createBlock(_component_FridgeDetailsCoolingAssistSettingsItem, {
              class: "fridgecoolingassistsettings-page-content-content-item",
              key: item.index,
              index: item.index,
              modeName: item.modeName,
              descriptionText: item.descriptionText,
              note: item.note,
              initialMinutes: item.initialMinutes,
              initialSeconds: item.initialSeconds,
              isSecondsValid: item.isSecondsValid,
              minMinutes: item.minMinutes,
              maxMinutes: item.maxMinutes,
              minSeconds: item.minSeconds,
              maxSeconds: item.maxSeconds,
              onSelectTime: _ctx.selectSetting
            }, null, 8, ["index", "modeName", "descriptionText", "note", "initialMinutes", "initialSeconds", "isSecondsValid", "minMinutes", "maxMinutes", "minSeconds", "maxSeconds", "onSelectTime"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1
      }, 8, ["currentPageIndex", "initialPageIndex", "onOnSelect"])
    ]),
    _createVNode(_component_FridgeDetailsConfirmCoolingAssistSettingDialog, {
      isShowDialog: _ctx.isShowConfirmDialog,
      modeName: _ctx.settingModeName,
      minutes: _ctx.settingMinutes,
      seconds: _ctx.settingSeconds,
      isValidSeconds: _ctx.isValidSeconds,
      onClickCancel: _ctx.confirmCancel,
      onClickSend: _ctx.confirmSend
    }, null, 8, ["isShowDialog", "modeName", "minutes", "seconds", "isValidSeconds", "onClickCancel", "onClickSend"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: _ctx.isShowCompletion,
      dialogType: _ctx.completionDialogType,
      title: _ctx.completionDialogTitle,
      message: _ctx.completionDialogMessage,
      negativeLabel: _ctx.completionDialogButtonTitle,
      onNegativeClick: _ctx.completionCloseButtonHandler
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "negativeLabel", "onNegativeClick"]),
    _createVNode(_component_CommonDesignDialog, {
      isShowDialog: !!_ctx.handleApiError,
      dialogType: _ctx.typeApiError,
      title: _ctx.apiErrorTitle,
      message: _ctx.getApiErrorMessage,
      positiveLabel: _ctx.retryButtonTitle,
      negativeLabel: _ctx.okButtonTitle,
      onPositiveClick: _ctx.retryApiErrorHandler,
      onNegativeClick: _ctx.okApiErrorHandler
    }, null, 8, ["isShowDialog", "dialogType", "title", "message", "positiveLabel", "negativeLabel", "onPositiveClick", "onNegativeClick"])
  ]))
})